import { LoadableAfterPaint } from '@confluence/loadable';

export const ArchiveSpacePortal = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchiveSpacePortal" */ '../src/ArchiveSpacePortal.tsx'
			)
		).ArchiveSpacePortal,
	name: 'ArchiveSpacePortal',
});
